export default class POI {
    constructor() {
        this.id = null;
        this.lat = null;
        this.lng = null;
        this.quarter = null;
        this.city = null;
        this.poi_name = null;
        this.street = null;
        this.number = null;

        this.district = '';
        this.quarter = '';
    }

    reset() {
        this.id = null;
        this.lat = null;
        this.lng = null;
        this.city = null;
        this.poi_name = null;
        this.street = null;
        this.number = null;

        this.district = '';
        this.quarter = '';
    }

    from_order_poi(order)
    {
        this.lat = order.poi_lat || this.client_lat;
        this.lng = order.poi_lng || this.client_lng;
        this.quarter = order.quarter;
        this.city = order.city;
        this.poi_name = order.poi_name;
        this.street = order.street;
        this.number = order.number;
    }

    from_order_dst(order)
    {
        this.lat = order.dst_lat || this.dst_client_lat;
        this.lng = order.dst_lng || this.dst_client_lng;
        this.quarter = order.dst_quarter;
        this.city = order.dst_city;
        this.poi_name = order.dst_name;
        this.street = order.dst_street;
        this.number = order.dst_number;
    }

    toPOIString() {
        let ret = '';
        const has_name = this.name !== null && this.name !== '' && this.name !== undefined;
        const has_street = this.street !== null && this.street !== '' && this.street !== undefined;
        const has_number = this.number !== null && this.number !== '' && this.number !== undefined;

        if (has_name) {
            ret += this.name;
        }

        if (!has_street && has_number) {
            ret += ' ' + this.number;
        }

        if (has_street) {
            ret += ' (' + this.street;
            if (has_number) {
                ret += ' ' + this.number;
            }
            ret += ')';
        }

        const has_district = this.district !== null && this.district !== '' && this.district !== undefined;
        const has_quarter = this.quarter !== null && this.quarter !== '' && this.quarter !== undefined;

        if (has_district || has_quarter) {
            ret += ' [';
            if (has_quarter) {
                ret += this.quarter;
            }
            if (has_quarter && has_district) {
                ret += ', ';
            }
            if (has_district) {
                ret += this.district;
            }
            ret += ']';
        }

        return ret;
    }

    toPOINameSearchString() {
        let ret = '';
        if (this.street === null) {
            ret += this.name;
        } else {
            ret += this.name + ' (' + this.street + ' ' + this.number + ')';
        }

        const has_district = this.district !== null && this.district !== '' && this.district !== undefined;
        const has_quarter = this.quarter !== null && this.quarter !== '' && this.quarter !== undefined;

        if (has_district || has_quarter) {
            ret += ' [';
            if (has_quarter) {
                ret += this.quarter;
            }
            if (has_quarter && has_district) {
                ret += ', ';
            }
            if (has_district) {
                ret += this.district;
            }
            ret += ']';
        }

        return ret;
    }

    toPOINameString() {   
        var ret = '';
        ret += this.name;
        return ret;
    };

    
    toCityPOIString() {
        let ret = '';
        if (this.city && this.city !== '') {
            ret += this.city;
        }
        const poi = this.toPOIString();
        if (this.city && this.city !== '' && poi && poi !== '') {
            ret += ' ';
        }
        if (poi && poi !== '') {
            ret += poi;
        }
        return ret;
    }

    copy_from_address(address) {
        this.city = address?.city ?? null;
        this.name = address?.street ?? null;
        this.street = null;
        this.number = address?.number ?? null;
    }

    copy_from_poi(poi) {
        this.id = poi.id ?? null;
        this.lat = poi.lat ?? null;
        this.lng = poi.lng ?? null;

        this.city = poi.city ?? '';
        this.name = poi.name ?? '';
        this.street = poi.street ?? null;
        this.number = poi.number ?? '';

        this.district = poi.district ?? '';
        this.quarter = poi.quarter ?? '';
    }

    copy_from_order(order) {
        this.city = order.city ?? '';
        this.lat = order.lat ?? null;
        this.lng = order.lng ?? null;
        this.street = order.street ?? null;
        this.name = order.poi_name ?? null;
        this.number = order.number ?? '';
        this.district = order.poi_district ?? '';
        this.quarter = order.poi_quarter ?? '';
    }

    copy_dst_from_order(order) {
        this.city = order.dst_city ?? '';
        this.lat = order.lat ?? null;
        this.lng = order.lng ?? null;
        this.street = order.dst_street ?? null;
        this.name = order.dst_name ?? null;
        this.number = order.dst_number ?? '';
        this.district = order.dst_district ?? '';
        this.quarter = order.dst_quarter ?? '';
    }

    copy_from_search(address) {
        this.id = address.id ?? null;
        this.lat = address.lat ?? null;
        this.lng = address.lng ?? null;
        this.city = address.city ?? '';
        this.street = address.street ?? null;
        this.name = address.name ?? null;
        this.number = address.number ?? '';
        this.quarter = address.quarter ?? '';
    }

    copy_from_track(order) {
        this.lat = order.client_lat ?? null;
        this.lng = order.client_lng ?? null;
    }

    copy_dst_from_track(order) {
        this.lat = order.dst_client_lat ?? null;
        this.lng = order.dst_client_lng ?? null;
    }

    has_gps() {
        return this.lat !== null && this.lng !== null;
    }

    is_poi() {
        return this.has_gps() || this.street !== null;
    }

    is_valid() {
        return this.is_poi();
    }

    is_number_needed() {
        if (!this.name && this.name !== '') return false;
        if (this.is_poi() && this.street === null && this.number.trim() !== '') return true;
        if (this.is_poi()) return false;
        return true;
    }

    display(short)
    {
        let ret = ""
        if(this.city)
        {
            ret += this.city + ' ';
        }
        if(this.poi_name && this.street)
        {
            ret += this.poi_name;
            if(!short)
            {
                ret += "(" + this.street;
                if (this.number) {
                    ret += " " + this.number;
                }
                ret += ")";
            }
        }
        else if (this.poi_name)
        {
            ret += " " + this.poi_name;
            if(this.number)
            {
                ret += " " + this.number;
            }
        }
        if (!short && this.quarter) {
            ret += " [" + this.quarter + "]";
        }
        return ret;
    }
}
